setTimeout(function(){
// $('.pplr-swatch-element.pplrimage').removeClass('selected')

 $('.grid__item,.predictive-search-item,.card-wrapper').each(function(){
  var _this= $(this);
  var handle = _this.find('.card__heading a').attr('href') || _this.find('.predictive-search-item__link').attr('href')
  if(handle != undefined && handle != '#' && handle.indexOf("/products/") > -1){
    handle=handle.split('/products/')[1];
    handle=handle.split('?')[0];
       // console.log(handle)
    if(handle == 'products/personalised-name-balls-copy' ){
      // console.log('okkkkk')
      _this.find('span.price-item.price-item--sale.price-item--last').text('$70.00 AUD')
    }else if(handle == 'personalised-name-balls-copy' ){
      // console.log('nooooo')
        _this.remove()
    }
  };
 })

  
// $('.price').text('$99.00')

// var e = new Event("change");
// var element = document.querySelector('variant-selects')
// element.dispatchEvent(e);
  
//     function ambxx(){
  
//         $('option').removeAttr('selected', 'selected')
//         if($('span.pplr-swatch-element.pplrimage.selected').attr('data-val') == 'White ball' ){
//         $(".select__select option[value='White ball']").attr('selected', 'selected')
//         }else if($('span.pplr-swatch-element.pplrimage.selected').attr('data-val') == 'Black Ball' ){
//         $(".select__select option[value='Black Ball']").attr('selected', 'selected')
//         }else if($('span.pplr-swatch-element.pplrimage.selected').attr('data-val') == 'Purple Glitter ball' ){
//         $(".select__select option[value='Purple Glitter ball']").attr('selected', 'selected')
//         }else if($('span.pplr-swatch-element.pplrimage.selected').attr('data-val') == 'Purple Gold Ball' ){
//         $(".select__select option[value='Purple Gold Ball']").attr('selected', 'selected')
//         }else if($('span.pplr-swatch-element.pplrimage.selected').attr('data-val') == 'Platinum Ball Limited Edition' ){
//         $(".select__select option[value='Platinum Ball Limited Edition']").attr('selected', 'selected')
//         }else if($('span.pplr-swatch-element.pplrimage.selected').attr('data-val') == 'Black Midnight ball' ){
//         $(".select__select option[value='Black Midnight ball']").attr('selected', 'selected')
//         }else if($('span.pplr-swatch-element.pplrimage.selected').attr('data-val') == 'HMB-Blue' ){
//         $(".select__select option[value='Blue Ball']").attr('selected', 'selected')
//         }else if($('span.pplr-swatch-element.pplrimage.selected').attr('data-val') == 'Green Ball' ){
//         $(".select__select option[value='Green Ball']").attr('selected', 'selected')
//         }else if($('span.pplr-swatch-element.pplrimage.selected').attr('data-val') == 'Gold Ball' ){
//         $(".select__select option[value='Gold Ball']").attr('selected', 'selected')
//         }else if($('span.pplr-swatch-element.pplrimage.selected').attr('data-val') == 'Camo Blue Ball' ){
//         $(".select__select option[value='Camo Blue Ball']").attr('selected', 'selected')
//         }else if($('span.pplr-swatch-element.pplrimage.selected').attr('data-val') == 'Camo Grey Ball' ){
//         $(".select__select option[value='Camo Grey Ball']").attr('selected', 'selected')
//         }else if($('span.pplr-swatch-element.pplrimage.selected').attr('data-val') == 'Pink Ball' ){
//         $(".select__select option[value='Pink Ball']").attr('selected', 'selected')
//         }else if($('span.pplr-swatch-element.pplrimage.selected').attr('data-val') == 'Red/Black Ball' ){
//         $(".select__select option[value='Red/Black Ball']").attr('selected', 'selected')
//         }else if($('span.pplr-swatch-element.pplrimage.selected').attr('data-val') == 'Silver Ball' ){
//         $(".select__select option[value='Silver Ball']").attr('selected', 'selected')
//         }else if($('span.pplr-swatch-element.pplrimage.selected').attr('data-val') == 'Star Wars Limited Edition' ){
//         $(".select__select option[value='Star Wars Limited Edition']").attr('selected', 'selected')
//         }else if($('span.pplr-swatch-element.pplrimage.selected').attr('data-val') == 'HMB Blue' ){
//         $(".select__select option[value='Blue Ball']").attr('selected', 'selected')
//         }else if($('span.pplr-swatch-element.pplrimage.selected').attr('data-val') == 'Black midnight ball' ){
//         $(".select__select option[value='Black Midnight Ball']").attr('selected', 'selected')
//         }
      
//       setTimeout(function(){
//           // var e = new Event("change");
//           // var element = document.querySelector('variant-selects')
//           // element.dispatchEvent(e);
//       },300);

//   }

// ======================================================================================
  
//   setTimeout(function(){
//     // ambxx()
//   },3000);

// ======================================================================================


// $('.pplr-wrapper.pplr-choose-ball-colour span.pplr-swatch-element.pplrimage').click(function(e){
//       // console.log('okokokok')
//     setTimeout(function(){
//       // ambxx()
//   },100);
// })

// ======================================================================================

function ambxx(){
  
  var ambx = $('span.pplr-swatch-element.pplrimage.selected').attr('data-val')
  // console.log('imgxx =>  ', ambx)
  
  $(current_product.variants).each(function(ee){
    var titlxx = current_product.variants[ee].title
    // console.log('titlxx',titlxx)
    
      if(ambx == titlxx){
          console.log('titlxx =>  ',titlxx)
  
          $(".select__select option").each(function(){
             var opts_loop =$(this).attr('value');
              // console.log(opts_loop)
      
            if(titlxx == opts_loop){
              // console.log('matched',opts_loop)              
              $('option').removeAttr('selected', 'selected')
              $('.select__select option[value="'+titlxx+'"]').attr('selected', 'selected')
              
                 setTimeout(function(){
                    var e = new Event("change");
                    var element = document.querySelector('variant-selects')
                    element.dispatchEvent(e);
                  },300);
            }
        });
    }
  })
}

// ======================================================================================


  setTimeout(function(){
    // ambxx()
  },3000);


// ======================================================================================
  
$('.pplr-wrapper.pplr-choose-ball-colour span.pplr-swatch-element.pplrimage').click(function(e){
      // console.log('changee')
    setTimeout(function(){
      // ambxx()
  },500);
})

// ======================================================================================

          
},1000);
